/* tslint:disable */

/**
 * Futures (COIN-M) REST API
 *
 * Access market data, manage accounts, and trade COIN-M perpetual and delivery futures.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface ModifyMultipleOrdersBatchOrdersParameterInner
 */
export interface ModifyMultipleOrdersBatchOrdersParameterInner {
    /**
     * Sub-order ID, required when clientOrderId is not sent.
     * @type {number | bigint}
     * @memberof ModifyMultipleOrdersBatchOrdersParameterInner
     */
    orderId?: number | bigint;
    /**
     * Client order ID, required when orderId is not sent. Only support letters, numbers and underscores, and must be unique within 24 hours.
     * @type {string}
     * @memberof ModifyMultipleOrdersBatchOrdersParameterInner
     */
    origClientOrderId?: string;
    /**
     * Trading symbol
     * @type {string}
     * @memberof ModifyMultipleOrdersBatchOrdersParameterInner
     */
    symbol: string;
    /**
     * Trading side
     * @type {string}
     * @memberof ModifyMultipleOrdersBatchOrdersParameterInner
     */
    side: ModifyMultipleOrdersBatchOrdersParameterInnerSideEnum;
    /**
     * Order quantity, cannot be sent with closePosition=true. **After CM migration, this parameter becomes mandatory** (each batch element must send both `price` and `quantity`).
     * @type {number}
     * @memberof ModifyMultipleOrdersBatchOrdersParameterInner
     */
    quantity?: number;
    /**
     * Latest token price. **After CM migration, this parameter becomes mandatory** (each batch element must send both `price` and `quantity`).
     * @type {number}
     * @memberof ModifyMultipleOrdersBatchOrdersParameterInner
     */
    price?: number;
    /**
     * User-defined modification identifier, returned as-is in the response. Optional; not validated for uniqueness.
     * @type {number | bigint}
     * @memberof ModifyMultipleOrdersBatchOrdersParameterInner
     */
    modifyId?: number | bigint;
    /**
     *
     * @type {number | bigint}
     * @memberof ModifyMultipleOrdersBatchOrdersParameterInner
     */
    recvWindow?: number | bigint;
    /**
     * Unix timestamp in milliseconds used to sign the request. The value must reflect the current client time and is validated by the server for signed endpoints.
     * @type {number | bigint}
     * @memberof ModifyMultipleOrdersBatchOrdersParameterInner
     */
    timestamp: number | bigint;
}

export const ModifyMultipleOrdersBatchOrdersParameterInnerSideEnum = {
    BUY: 'BUY',
    SELL: 'SELL',
} as const;

export type ModifyMultipleOrdersBatchOrdersParameterInnerSideEnum =
    (typeof ModifyMultipleOrdersBatchOrdersParameterInnerSideEnum)[keyof typeof ModifyMultipleOrdersBatchOrdersParameterInnerSideEnum];
